import React, { Component } from "react";
import { Header, Segment, Image, Button } from "semantic-ui-react";
import request from "../../utils/request";

class HelpApp extends Component {
  state = {
    settings: {
      apk_filename: "bump.apk"
    },
    qrCode: '',
    paxQrCode: ''
  };
  getApkUrl = e => {
    e && e.preventDefault();
    let payload = { isPax: false };
    return request.post(this, "api:/apk", payload).then(resp => {
      // handle success
      if (resp && resp.url) {
        window.open(resp.url)
      }
    });
  };
  getPaxApkUrl = e => {
    e && e.preventDefault();
    let payload = { isPax: true };
    return request.post(this, "api:/apk", payload).then(resp => {
      // handle success
      if (resp && resp.url) {
        window.open(resp.url)
      }
    });
  };
  getApkQrCode = () => {
    let payload = { isPax: false };
    return request.getQrCode(this, "api:/apk-qr-code", payload).then(resp => {
      // handle success
      if (resp) {
        this.setState({
          qrCode: resp
        })
      }
    });
  }
  getPaxApkQrCode = () => {
    let payload = { isPax: true };
    return request.getQrCode(this, "api:/apk-qr-code", payload).then(resp => {
      // handle success
      if (resp) {
        this.setState({
          paxQrCode: resp
        })
      }
    });
  }
  render() {
    const apkFilename = this.state.settings.apk_filename;

    return (
      <Segment basic>
        <Header as="h2">
          <Header.Subheader>
            Your Android application for tablets may be downloaded from the links
            below.
          </Header.Subheader>
        </Header>

        <Header as="h2">
          QR Codes are only valid for 10 minutes!
        </Header>

        <Header as="h3">
          BUMP APK
          </Header>
        <Button onClick={this.getApkUrl}>
          Download
          </Button>
        <Button onClick={this.getApkQrCode}>
          Get new Qr Code
          </Button>
        <Segment basic>
          <Image src={this.state.qrCode} />
        </Segment>

        <Header as="h3">
          PAX APK
        </Header>
        <Button onClick={this.getPaxApkUrl}>
          Download
          </Button>
        <Button onClick={this.getPaxApkQrCode}>
          Get new Qr Code
        </Button>
        <Segment basic>
          <Image src={this.state.paxQrCode} />
        </Segment>

        <Header as="h3">
          To setup the Bump application on a new Android tablet, please follow
          the steps below:
        </Header>
        <Header as="h4">Bluetooth Printer Pairing:</Header>
        <ol>
          <li>Make sure your mobile printer is turned on.</li>
          <li>Load the &quot;Settings&quot; app from your Android device.</li>
          <li>
            Tap on Bluetooth, then tap &quot;Scan&quot; to find your printer.
          </li>
          <li>
            Look on the bottom of the mobile printer for a &quot;Serial&quot;
            number, then tap on the Bluetooth device listed on your tablet that
            matches this serial number.
          </li>
          <li>
            If you are asked to enter a PIN number, enter &quot;0&quot;. Note
            the PIN could also be &quot;0000&quot; if &quot;0&quot; does not
            work.
          </li>
        </ol>
        <Header as="h4">Android Application Installation</Header>
        <ol>
          <li>
            Open the browser app on your Android device and download the app
            from the link above.
          </li>
          <li>
            Once the download has begun, swipe downwards from the top of the
            device to view your notifications area. You should see the download
            named &quot;{apkFilename}&quot; listed here.
          </li>
          <li>
            Tap on the &quot;{apkFilename}&quot; file in your notifications
            list.
          </li>
          <li>
            You *may* see an &quot;Install Blocked&quot; message. If so, tap the
            &quot;Settings&quot; button. If not, continue to step #6.
          </li>
          <li>
            Check the box that says &quot;Unknown Sources&quot; on this page,
            and then tap &quot;OK&quot; from the next pop-up.
          </li>
          <li>
            Tap the &quot;Install&quot; button on the bottom-right corner.
          </li>
          <li>
            Wait for the app to install, then tap &quot;Open&quot;.
          </li>
        </ol>

        <Header as="h4">Authorize the Device</Header>
        <ol>
          <li>
            Log into the Manager Panel and click on &quot;Devices&quot; in the
            top menu.
          </li>
          <li>
            On this page, you will see a device named "Unregistered Device"
            listed at the top. Click the icon on the right side of the table to
            edit the device, then enter a name for the device in the "NAME:"
            field.
          </li>
          <li>Click the "Submit" button to save the device.</li>
        </ol>

        <Header as="h4">The tablet is now setup and ready for sales.</Header>
      </Segment>
    );
  }
}

export default HelpApp;
